import React from 'react';
import AppRouter from './AppRouter';
import { useLoader } from './context/LoaderContext';
import { ErrorBoundary, Loader, Offline } from './components/common';
import { Toaster } from 'react-hot-toast';
import { NodeSocketProvider } from './context/NodeSocketContext';

function App() {
  const { isLoading: isLoaderRequired } = useLoader();
  return (
    <ErrorBoundary>
      <NodeSocketProvider>
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerClassName="toaster-container"
        />

        <AppRouter />

        {isLoaderRequired && <Loader />}
        <Offline />
      </NodeSocketProvider>
    </ErrorBoundary>
  );
}

export default App;
